import { Mode } from '@/types/main'

type Options = { withoutUuid?: boolean; withoutCity?: boolean }

export const getApiBaseUrl = (
  city: string,
  version: number,
  options?: Options,
) => {
  // Формируем новый url для v4
  const publicConfig = useRuntimeConfig().public

  const API_BASE_URL = (publicConfig.API_BASE_URL as string) || ''
  const API_BASE_URL_KG = (publicConfig.API_BASE_URL_KG as string) || ''
  const BRAND_UUID = (publicConfig.BRAND_UUID as string) || ''
  const MODE = (publicConfig.MODE as string) || ''

  const { host } = useRequestURL()

  const API_URL = getApiUrl(API_BASE_URL, API_BASE_URL_KG, MODE as Mode, host)

  let baseUrl = `${API_URL}/v${version}`

  if (!options?.withoutUuid) baseUrl += `/${BRAND_UUID}`

  if (!options?.withoutCity) baseUrl += `/${city}`

  return baseUrl
}
